import { render, staticRenderFns } from "./WebReportProjekt.vue?vue&type=template&id=47ddbc16&scoped=true&lang=pug&"
import script from "./WebReportProjekt.vue?vue&type=script&lang=ts&"
export * from "./WebReportProjekt.vue?vue&type=script&lang=ts&"
import style0 from "./WebReportProjekt.vue?vue&type=style&index=0&id=47ddbc16&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ddbc16",
  null
  
)

export default component.exports